
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 128 128","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.256 45.051C25.256 86.15 64 121.693 64 121.693s38.744-35.543 38.744-76.642a38.744 38.744 0 00-77.488 0z","fill":"#fd646f"}}),_c('circle',{attrs:{"cx":"64","cy":"45.051","fill":"#dff6fd","r":"27.601"}}),_c('path',{attrs:{"d":"M64 27.066l-17.854 15.18h6.128v17.629h7.734V48.894h7.984v10.981h7.734V42.246h6.128z","fill":"#2edffc"}})])
          )
        }
      }
    